import {
  ComponentDescriptorOrArray,
  getRendererFromDescriptor,
  useField,
  usePage,
} from '@kizi/comparator-core';
import { Div, DivProps, Heading, HeadingProps, P } from '@kizi/core-components';
import React from 'react';

export interface CheckoutContentBlockProps extends DivProps {
  heading: HeadingProps;
  content?: ComponentDescriptorOrArray | string;
  dependsOn?: {
    fieldName: string;
    fieldValue: string | number | number[] | boolean;
  };
}
interface State {
  providerRes?: {
    meta?: {
      input: {
        [key: string]: unknown;
        is_cb_member?: string;
      };
    };
  };
}

export const CheckoutContentBlock: React.FC<CheckoutContentBlockProps> = ({
  heading,
  content,
  dependsOn,
  ...restProps
}) => {
  const { state } = usePage();
  const field = useField(dependsOn?.fieldName ?? '');
  if (dependsOn) {
    if (!field) return null;
    const _state = state as State;
    if (_state?.providerRes?.meta?.input?.is_cb_member === 'optout')
      return null;
    if (
      Array.isArray(dependsOn?.fieldValue) &&
      dependsOn?.fieldValue.includes(Number(field.value))
    )
      return null;
    if (field.value !== dependsOn?.fieldValue) return null;
  }
  const parseContent = (blockContent: string) => {
    const searchExp = /(\{{)(.*?)(\}})/gi;
    const fields = blockContent.match(searchExp) ?? [];
    fields.forEach((f) => {
      const name = f.replace('{{', '').replace('}}', '');
      blockContent = blockContent.replace(
        `${f}`,
        (state as any)?.providerRes.meta['input'][name],
      );
    });
    return blockContent;
  };

  const parsedContent =
    typeof content === 'string' ? parseContent(content) : content;
  const contentWrapper =
    typeof parsedContent === 'string' ? (
      <P>{parsedContent}</P>
    ) : (
      getRendererFromDescriptor(parsedContent)
    );

  return (
    <Div
      display="flex"
      flexDirection="column"
      variant="primaryCard"
      {...restProps}
    >
      <Heading variant="H4" as="h4" marginTop={0} {...heading} />
      {contentWrapper}
    </Div>
  );
};
